// src/components/Logout.jsx
import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';
import axios from 'axios';
import { withRouter } from 'react-router-dom';

const API = `${process.env.REACT_APP_API_BASEURL}/logout`;

class Logout extends Component {
  state = { loading: false };

  handleLogout = async (e) => {
    e.preventDefault();
    if (this.state.loading) return;
    this.setState({ loading: true });

    try {
      await axios.post(`${API}?_method=DELETE`, {}, { withCredentials: true });
    } catch {
      // ignore
    } finally {
      try { localStorage.clear(); sessionStorage.clear(); } catch {}
      this.setState({ loading: false });
      this.props.history.replace('/sign-in');
    }
  };

  render() {
    return (
      <Button onClick={this.handleLogout} disabled={this.state.loading}>
        {this.state.loading ? 'Logging out…' : 'Logout'}
      </Button>
    );
  }
}

export default withRouter(Logout);
